<template>
    <button v-if="!hasLabel" type="button" class="kimsa-toggle" :class="stateClass" @click="onClick">
        <span class="kimsa-toggle-knob" />
    </button>
    <label v-else class="kimsa-toggle-field" :class="{ disabled, loading }" @click="onClick">
        <slot v-if="labelLeft" />
        <span class="kimsa-toggle" :class="stateClass">
            <span class="kimsa-toggle-knob" />
        </span>
        <slot v-if="!labelLeft" />
    </label>
</template>

<script>
export default {
    name: 'KimsaToggle',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        labelLeft: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        hasLabel(vm = this) {
            return !!vm.$slots.default
        },
        stateClass(vm = this) {
            return { on: vm.value, off: !vm.value, loading: vm.loading, disabled: vm.disabled }
        }
    },
    methods: {
        onClick() {
            const vm = this
            if (vm.loading || vm.disabled) return
            vm.$emit('input', !vm.value)
            vm.$emit('change', !vm.value)
        }
    }
}
</script>

<style scoped>
.kimsa-toggle-field {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.kimsa-toggle-field.disabled,
.kimsa-toggle-field.loading {
    cursor: default;
}

.kimsa-toggle {
    display: inline-block;
    width: 40px;
    height: 22px;
    border-radius: 11px;
    background: var(--v-outline2-base);
    position: relative;
    cursor: pointer;
    border: none;
    transition: background 0.2s;
    flex-shrink: 0;
    padding: 0;
}

.kimsa-toggle-field .kimsa-toggle {
    cursor: inherit;
}

.kimsa-toggle.on {
    background: var(--v-accent-base);
}

.kimsa-toggle.loading {
    opacity: 0.6;
    cursor: default;
}

.kimsa-toggle.disabled {
    cursor: default;
    opacity: 0.85;
}

.kimsa-toggle-knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    transition: transform 0.2s;
}

.kimsa-toggle.on .kimsa-toggle-knob {
    transform: translateX(18px);
}
</style>
